import {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCalendar,
    cilChart,
    cilChartPie,
    cilCheck,
    cilChevronLeft,
    cilChevronRight,
    cilCloudDownload,
    cilCode,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilFile,
    cilGrid,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMinus,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPen,
    cilPencil,
    cilPeople,
    cilPlus,
    cilPrint,
    cilPuzzle,
    cilReportSlash,
    cilSave,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilCompress,
    cilUserUnfollow,
    cilChartLine,
    cilTruck
  } from '@coreui/icons';
  
  import { signet } from './signet';
  import { logo } from './logo';
  
  export const iconSubset = {
    cibCcAmex,
    cibCcApplePay,
    cibCcMastercard,
    cibCcPaypal,
    cibCcStripe,
    cibCcVisa,
    cibFacebook,
    cibGoogle,
    cibLinkedin,
    cibSkype,
    cibTwitter,
    cifBr,
    cifEs,
    cifFr,
    cifIn,
    cifPl,
    cifUs,
    cilAccountLogout,
    cilAlignCenter,
    cilAlignLeft,
    cilAlignRight,
    cilApplicationsSettings,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBasket,
    cilBell,
    cilBold,
    cilBookmark,
    cilCalculator,
    cilCalendar,
    cilChart,
    cilChartPie,
    cilCheck,
    cilChevronLeft,
    cilChevronRight,
    cilCloudDownload,
    cilCode,
    cilCommentSquare,
    cilContrast,
    cilCreditCard,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilFile,
    cilGrid,
    cilHome,
    cilInbox,
    cilIndentDecrease,
    cilIndentIncrease,
    cilItalic,
    cilJustifyCenter,
    cilLanguage,
    cilLayers,
    cilList,
    cilListNumbered,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMap,
    cilMediaPlay,
    cilMediaRecord,
    cilMenu,
    cilMinus
,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPaperclip,
    cilPaperPlane,
    cilPen,
    cilPencil,
    cilPeople,
    cilPlus,
    cilPrint,
    cilPuzzle,
    cilReportSlash,
    cilSave,
    cilSettings,
    cilShare,
    cilShareAll,
    cilShareBoxed,
    cilSpeech,
    cilSpeedometer,
    cilSpreadsheet,
    cilStar,
    cilSun,
    cilTags,
    cilTask,
    cilTrash,
    cilUnderline,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilUserUnfollow,
    cilCompress,
    cilTruck,
    cilChartLine,
    logo,
    signet
  };
  
  export enum IconSubset {
    cibCcAmex = 'cibCcAmex',
    cliCompress = 'cilCompress',
    cibCcApplePay = 'cibCcApplePay',
    cibCcMastercard = 'cibCcMastercard',
    cibCcPaypal = 'cibCcPaypal',
    cibCcStripe = 'cibCcStripe',
    cibCcVisa = 'cibCcVisa',
    cibFacebook = 'cibFacebook',
    cibGoogle = 'cibGoogle',
    cibLinkedin = 'cibLinkedin',
    cibSkype = 'cibSkype',
    cibTwitter = 'cibTwitter',
    cifBr = 'cifBr',
    cifEs = 'cifEs',
    cifFr = 'cifFr',
    cifIn = 'cifIn',
    cifPl = 'cifPl',
    cifUs = 'cifUs',
    cilAccountLogout = 'cilAccountLogout',
    cilAlignCenter = 'cilAlignCenter',
    cilAlignLeft = 'cilAlignLeft',
    cilAlignRight = 'cilAlignRight',
    cilApplicationsSettings = 'cilApplicationsSettings',
    cilArrowBottom = 'cilArrowBottom',
    cilArrowRight = 'cilArrowRight',
    cilArrowTop = 'cilArrowTop',
    cilBasket = 'cilBasket',
    cilBell = 'cilBell',
    cilBold = 'cilBold',
    cilBookmark = 'cilBookmark',
    cilCalculator = 'cilCalculator',
    cilCalendar = 'cilCalendar',
    cilChart = 'cilChart',
    cilChartPie = 'cilChartPie',
    cilCheck = 'cilCheck',
    cilChevronLeft = 'cilChevronLeft',
    cilChevronRight = 'cilChevronRight',
    cilCloudDownload = 'cilCloudDownload',
    cilCode = 'cilCode',
    cilCommentSquare = 'cilCommentSquare',
    cilContrast = 'cilContrastś',
    cilCreditCard = 'cilCreditCard',
    cilCursor = 'cilCursor',
    cilDescription = 'cilDescription',
    cilDollar = 'cilDollar',
    cilDrop = 'cilDrop',
    cilEnvelopeClosed = 'cilEnvelopeClosed',
    cilEnvelopeOpen = 'cilEnvelopeOpen',
    cilFile = 'cilFile',
    cilGrid = 'cilGrid',
    cilHome = 'cilHome',
    cilInbox = 'cilInbox',
    cilIndentDecrease = 'cilIndentDecrease',
    cilIndentIncrease = 'cilIndentIncrease',
    cilItalic = 'cilItalic',
    cilJustifyCenter = 'cilJustifyCenter',
    cilLanguage = 'cilLanguage',
    cilLayers = 'cilLayers',
    cilList = 'cilList',
    cilListNumbered = 'cilListNumbered',
    cilLocationPin = 'cilLocationPin',
    cilLockLocked = 'cilLockLocked',
    cilMagnifyingGlass = 'cilMagnifyingGlass',
    cilMap = 'cilMap',
    cilMediaPlay = 'cilMediaPlay',
    cilMediaRecord = 'cilMediaRecord',
    cilMenu = 'cilMenu',
    cilMoon = 'cilMoon',
    cilNotes = 'cilNotes',
    cilOptions = 'cilOptions',
    cilPaperclip = 'cilPaperclip',
    cilPaperPlane = 'cilPaperPlane',
    cilPen = 'cilPen',
    cilPencil = 'cilPencil',
    cilPeople = 'cilPeople',
    cilPrint = 'cilPrint',
    cilPuzzle = 'cilPuzzle',
    cilReportSlash = 'cilReportSlash',
    cilSave = 'cilSave',
    cilSettings = 'cilSettings',
    cilShare = 'cilShare',
    cilShareAll = 'cilShareAll',
    cilShareBoxed = 'cilShareBoxed',
    cilSpeech = 'cilSpeech',
    cilSpeedometer = 'cilSpeedometer',
    cilSpreadsheet = 'cilSpreadsheet',
    cilStar = 'cilStar',
    cilSun = 'cilSun',
    cilTags = 'cilTags',
    cilTask = 'cilTask',
    cilTrash = 'cilTrash',
    cilUnderline = 'cilUnderline',
    cilUser = 'cilUser',
    cilUserFemale = 'cilUserFemale',
    cilUserFollow = 'cilUserFollow',
    cilUserUnfollow = 'cilUserUnfollow',
    logo = 'logo',
    signet = 'signet'
  }
  
  